import MultiSelectWithMenuModal from './MultiSelectWithMenuModal';

export default MultiSelectWithMenuModal;
